import { Component } from '@angular/core';

@Component({
  selector: 'app-file-preview-demo-api-spec',
  imports: [],
  templateUrl: './file-preview-demo-api-spec.component.html',
  styleUrl: './file-preview-demo-api-spec.component.scss',
})
export class FilePreviewDemoApiSpecComponent {}
